
// @ts-check

export default class PredictiveRoutingService {

  /** @ngInject **/
  constructor(
    $http,
    assetService,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.assetService = assetService;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  async getPredictiveRouting(accountId) {
    const url = this._serviceBaseUrl(accountId);
    const result = await this.$http.get(url);
    return result.data.rpcSettingItems;
  }

  async getPredictiveRoutingConfig(accountId, configId) {
    const url = this._serviceBaseUrl(accountId, configId);
    const result = await this.$http.get(url);
    return result.data.rpcSettingItem;
  }

  async createPredictiveRoutingConfig(accountId, config) {
    const url = this._serviceBaseUrl(accountId);
    const result = await this.$http.post(url, config);
    return result;
  }

  async updatePredictiveRoutingConfig(accountId, config) {
    const url = this._serviceBaseUrl(accountId, config.id);
    const result = await this.$http.patch(url, config);
    return result;
  }

  async deletePredictiveRoutingConfig(accountId, configId) {
    const url = this._serviceBaseUrl(accountId, configId);
    const result = await this.$http.delete(url);
    return result;
  }

  async getPredictiveRoutingConfigReferences(accountId, configId) {
    const url = this._serviceBaseUrl(accountId, configId) + '/InboundReferences';
    const result = await this.$http.get(url);
    return result;
  }

  async convertPredictiveRoutingConfigToAdvanced(accountId, payload) {
    const url = this._serviceBaseUrl(accountId) + '/toAdvanced?callsPerDay=' + payload.callCount;
    const result = await this.$http.post(url, payload.config);
    return result.data.rpcSettingItem;
  }

  async convertPredictiveRoutingConfigToBasic(accountId, payload) {
    const url = this._serviceBaseUrl(accountId) + '/toBasic?callsPerDay=' + payload.callCount;
    const result = await this.$http.post(url, payload.config);
    return result.data.rpcSettingItem;
  }

  _serviceBaseUrl(accountId, configId) {
    return this.serviceBaseUri + accountId + '/PredictiveRouting' + (configId ? '/' + configId : '');
  }

}